<template>
  <div id="List">
    <!-- banner -->
    <div
      v-if="
        (!Nav.lanmu.Logo && !Nav.PColumn) ||
          (Nav.lanmu.Logo == 'http://base.hope55.com' &&
            Nav.PColumn.Logo == 'http://base.hope55.com')
      "
      class="banner"
    ></div>
    <div
      v-else-if="Nav.lanmu.Logo == '' && !Nav.PColumn == ''"
      class="banner"
    ></div>
    <div
      v-else
      class="banner"
      :style="{
        'background-image':
          'url(' + (Nav.lanmu.Logo ? Nav.lanmu.Logo : Nav.PColumn.Logo) + ')'
      }"
    ></div>
    <!-- 导航 -->
    <div class="navList">
      <div class="topDh w1200">
        <!-- 当前位置 -->
        <address-bar :addressBarData="Nav"></address-bar>
      </div>
      <div class="main w1200">
        <div v-if="NId">
          <div v-if="CId == 6750" class="sxzxDetail">
            <div>
              <side-List :sideListData="sideListData"></side-List>
              <div class="sxDetails" v-html="List.Details"></div>
              <div class="clear"></div>
            </div>
            <!-- 分页 -->
            <!-- <div id="page_turn_box">
              <ul>
              	<li v-for="(item,index) in sideListData.PageBar" :key='index'>
              		<router-link :to='item.Url' :class="[ (pageIndex==item.Nab ||(!pageIndex&&item.Nab==1))?'on':'']">{{item.Name}}</router-link>
              	</li>
              </ul>
            </div> -->
          </div>
          <div v-else-if="CId == 6748" class="tzggDetail">
            <div class="wtDetails">
              <p class="title">{{ List.Title }}</p>
              <p class="related">
                <span>发布时间：{{ List.ShowTime }}</span>
                <em>点击：{{ List.Press }}次</em>
              </p>
              <div class="detail" v-html="List.Details"></div>
            </div>
            <wutu-List :wutuListData="wutuListData"></wutu-List>
            <div class="clear"></div>
          </div>
          <div v-else-if="CId == 6747" class="tzggDetail">
            <div>
              <div class="wtDetails">
                <p class="title">{{ List.Title }}</p>
                <p class="related">
                  <span>发布时间：{{ List.ShowTime }}</span>
                  <em>点击：{{ List.Press }}次</em>
                </p>
                <div class="detail" v-html="List.Details"></div>
              </div>
              <daitu-List :daituListData="daituListData"></daitu-List>
              <div class="clear"></div>
            </div>
          </div>
          <div v-else-if="CId == 6746" class="newsDetails">
            <div class="jsDetail">
              <div class="imgs"><img :src="List.Cover" alt="" /></div>
              <h1>{{ List.Title }}</h1>
              <p v-html="List.Details"></p>
            </div>
          </div>
          <div v-else class="newsDetails">
            <div class="details">
              <template>
                <p class="title">{{ List.Title }}</p>
                <p class="related_information">
                  <span>{{ List.ShowTime }}</span>
                  <em>{{ List.Press }}次</em>
                </p>
              </template>
              <div class="Details" v-html="List.Details"></div>
            </div>
          </div>
        </div>
        <div v-else id="infoBox">
          <div v-if="HType == 1" v-html="List.Info" class="singleBox"></div>
          <component-view
            v-else
            :option="{ dataList: List, componentType: currentValue }"
          ></component-view>
          <!-- 分页 -->
          <page-box
            :pageBoxData="List.PageBar"
            :pageIndex="PageIndex"
          ></page-box>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "../assets/css/list.css";
import addressBar from "@/components/addressBar";
import pageBox from "@/components/pageBox";
import componentView from "@/components/componentView";
import sideList from "@/components/sideList";
import wutuList from "@/components/wutuList";
import daituList from "@/components/daituList";
export default {
  name: "list",
  props: {
    pageIndex: {
      type: Number,
      default: 1
    }
  },
  components: {
    addressBar,
    pageBox,
    componentView,
    sideList,
    wutuList,
    daituList
  },
  data() {
    return {
      CId: this.$route.query.CId,
      NId: this.$route.query.NId,
      PageIndex: this.$route.query.PageIndex,
      HType: this.$route.query.HType,
      Nav: "",
      item: "",
      List: [],
      currentData: "",
      currentValue: "pageBox",
      sideList: [],
      wutuList: [],
      daituList: []
    };
  },
  created() {
    this.Nav = this.Curren.SetClassStyle(this.CId);
    this.Nav.List = [];
    this.Nav.lanmu.Fid > 0
      ? (this.Nav.List = this.$root.$children["0"].$children[
          "0"
        ].menuListOne.filter(ele => ele.ID == this.Nav.lanmu.Fid)[0].Children)
      : this.Nav.List.push(this.Nav.lanmu);
    //侧边栏无图新闻
    this.sideListData = this.Base.GetNewsInfoByCid(
      this.CId,
      false,
      this.PageIndex,
      "",
      16
    );
    this.wutuListData = this.Base.GetNewsInfoByCid(
      this.CId,
      false,
      this.PageIndex,
      "",
      10
    );
    this.daituListData = this.Base.GetNewsInfoByCid(
      this.CId,
      false,
      this.PageIndex,
      "",
      6
    );
    // console.log(this.wutuListData,11)
    if (this.$root.$children["0"].$children["0"].menuListOne) {
      this.$root.$children["0"].$children["0"].menuListOne.forEach(element => {
        // 确定菜单点击项
        element.ID == this.CId ? (element.On = true) : (element.On = false);
      });
    }
    if (this.NId) {
      //详情
      this.List = this.Base.GetNewsInfoByNid(this.NId);
      // console.log(this.List,"详情")
    } else if (this.HType == 1) {
      this.List = this.Base.GetSinglePageInfoByCid(this.CId);
    } else if (this.HType == 4) {
      if (this.CId == 6752) {
        //下载
        this.List = this.Base.GetFilesInfoByCid(
          this.CId,
          this.PageIndex,
          "",
          8
        );
        this.currentValue = "downList";
      }
    } else {
      if (this.CId == 6748 || this.CId == 6750 || this.CId == 6741) {
        //无图new
        this.List = this.Base.GetNewsInfoByCid(
          this.CId,
          false,
          this.PageIndex,
          "",
          6
        );
        this.currentValue = "noImgList";
        // console.log(this.List,"11")
      } else if (this.CId == 6747) {
        this.List = this.Base.GetNewsInfoByCid(
          this.CId,
          true,
          this.PageIndex,
          "",
          5
        );
        this.currentValue = "ImgList";
      } else if (this.CId == 6746) {
        this.List = this.Base.GetNewsInfoByCid(
          this.CId,
          true,
          this.PageIndex,
          "",
          5
        );
        this.currentValue = "jiaoshi";
      } else if (this.CId == 6749) {
        this.List = this.Base.GetNewsInfoByCid(
          this.CId,
          true,
          this.PageIndex,
          "",
          6
        );
        this.currentValue = "tuwen";
      } else if (this.CId == 6736) {
        this.List = this.Base.GetNewsInfoByCid(
          this.CId,
          true,
          this.PageIndex,
          "",
          6
        );
        this.currentValue = "zhuanye";
      } else if (this.CId == 6737) {
        this.List = this.Base.GetNewsInfoByCid(
          this.CId,
          true,
          this.PageIndex,
          "",
          6
        );
        this.currentValue = "xueke";
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/list.vue